import PRODUCT_TYPES from './ProductTypes';


const PRODUCT_TYPE_INFO = {
    [PRODUCT_TYPES.TRAVEL]: {
        name_en: 'Travel',
        name_fr: 'Voyages',

        slug_en: PRODUCT_TYPES.TRAVEL,
        slug_fr: 'voyages',
    },

    [PRODUCT_TYPES.CASH_BACK]: {
        name_en: 'Cash back',
        name_fr: 'Remise en argent',

        slug_en: PRODUCT_TYPES.CASH_BACK,
        slug_fr: 'remise-en-argent',
    },

    [PRODUCT_TYPES.LOW_INTEREST]: {
        name_en: 'Low interest',
        name_fr: 'Faible taux d’intérêt',

        slug_en: PRODUCT_TYPES.LOW_INTEREST,
        slug_fr: 'faible-taux-d-interets',
    },

    [PRODUCT_TYPES.BALANCE_TRANSFER]: {
        name_en: 'Balance transfer',
        name_fr: 'Transfert de solde',

        slug_en: PRODUCT_TYPES.BALANCE_TRANSFER,
        slug_fr: 'transfert-de-solde',
    },

    [PRODUCT_TYPES.STORE_CREDIT]: {
        name_en: 'Store credit',
        name_fr: 'Rabais en magasin',

        slug_en: PRODUCT_TYPES.STORE_CREDIT,
        slug_fr: 'credit-magasins',
    },

    [PRODUCT_TYPES.SECURED]: {
        name_en: 'Secured',
        name_fr: 'Guarantie',

        slug_en: PRODUCT_TYPES.SECURED,
        slug_fr: 'guarantie',
    },
};

export default PRODUCT_TYPE_INFO;
